import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { mockIndustries } from '../mock';
import './Industries.css';

const Industries = () => {
  return (
    <div className="industries-page">
      <section className="page-hero">
        <h1 className="display-huge">Industries We Serve</h1>
        <p className="body-large" style={{ marginTop: '32px', maxWidth: '800px', margin: '32px auto 0' }}>
          Specialized AI chat support agents tailored to your industry's unique needs, workflows, and compliance requirements.
        </p>
      </section>

      <section className="industries-list">
        <div className="industries-grid-full">
          {mockIndustries.map((industry) => (
            <Link 
              key={industry.id} 
              to={`/industries/${industry.id}`}
              className="industry-card-full dark-hover"
            >
              <div className="industry-image-full" style={{ backgroundImage: `url(${industry.image})` }}></div>
              <div className="industry-content-full">
                <h2 className="heading-1">{industry.name}</h2>
                <p className="body-small" style={{ marginTop: '12px', color: 'var(--brand-primary)', fontWeight: '500' }}>
                  {industry.tagline}
                </p>
                <p className="body-medium" style={{ marginTop: '20px' }}>
                  {industry.description}
                </p>
                <div className="features-list">
                  {industry.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <div className="card-arrow">
                  <ArrowRight size={24} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Industries;